import { motion } from "framer-motion";
import { AmazonLogo, BookOpen, BookBookmark } from "@phosphor-icons/react";

const AMAZON_URL =
  "https://www.amazon.se/s?i=stripbooks&rh=p_27%3AUlrika%2BLogart&language=en&ref=dp_byline_sr_book_1";
const GOODREADS_URL =
  "https://www.goodreads.com/author/show/60231573.Ulrika_Logart";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.15, ease: "easeOut" },
  }),
};

const PURCHASE_OPTIONS = [
  {
    title: "Paperback",
    subtitle: "A beautifully printed edition to hold, read aloud, and treasure.",
    icon: BookOpen,
    url: AMAZON_URL,
    label: "Order on Amazon",
    testId: "purchase-paperback",
  },
  {
    title: "E-book",
    subtitle: "Read anywhere, anytime — perfect for bedtime stories on the go.",
    icon: BookBookmark,
    url: AMAZON_URL,
    label: "Get E-book on Amazon",
    testId: "purchase-ebook",
  },
];

export default function PurchaseSection() {
  return (
    <section
      id="purchase"
      data-testid="purchase-section"
      className="relative py-24 md:py-32"
    >
      <div className="section-separator mb-24 md:mb-32" />

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={0}
          className="text-center mb-16"
        >
          <p
            className="text-sm tracking-widest uppercase mb-4"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 400,
              color: "var(--text-secondary)",
              letterSpacing: "0.15em",
            }}
          >
            Get Your Copy
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl mb-6"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 400,
              color: "var(--text-primary)",
              lineHeight: 1.2,
            }}
          >
            Read <span style={{ color: "var(--gold)" }}>The Disco Whale</span>
          </h2>
          <div className="gold-divider mx-auto mb-8" />
          <p
            className="text-base md:text-lg max-w-lg mx-auto"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 300,
              color: "var(--text-secondary)",
              lineHeight: 1.7,
            }}
          >
            Available now on Amazon in paperback and e-book format.
            Share the magic of Thomas's adventure with a little one.
          </p>
        </motion.div>

        {/* Purchase cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-3xl mx-auto">
          {PURCHASE_OPTIONS.map((option, i) => (
            <motion.a
              key={option.testId}
              href={option.url}
              target="_blank"
              rel="noopener noreferrer"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              variants={fadeUp}
              custom={i + 1}
              data-testid={option.testId}
              className="block p-8 md:p-10 rounded-sm text-center no-underline transition-all duration-300"
              style={{
                backgroundColor: "var(--bg-surface)",
                border: "1px solid rgba(234,208,161,0.08)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "rgba(234,208,161,0.25)";
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 16px 48px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "rgba(234,208,161,0.08)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <option.icon
                size={36}
                weight="light"
                style={{
                  color: "var(--gold)",
                  margin: "0 auto 1.25rem",
                }}
              />
              <h3
                className="text-xl mb-2"
                style={{
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: 500,
                  color: "var(--text-primary)",
                }}
              >
                {option.title}
              </h3>
              <p
                className="text-sm mb-6"
                style={{
                  fontFamily: "'Outfit', sans-serif",
                  fontWeight: 300,
                  color: "var(--text-secondary)",
                  lineHeight: 1.7,
                }}
              >
                {option.subtitle}
              </p>
              <span
                className="inline-flex items-center gap-2 text-sm tracking-wide uppercase"
                style={{
                  fontFamily: "'Outfit', sans-serif",
                  fontWeight: 500,
                  color: "var(--gold)",
                  letterSpacing: "0.08em",
                }}
              >
                {option.label}
                <AmazonLogo size={18} weight="bold" />
              </span>
            </motion.a>
          ))}
        </div>

{/* Goodreads link removed */}
      </div>
    </section>
  );
}
